import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { STATUSES } from "./api";

export const StatusSelect = ({ value, onChange, testId }) => {
  const current = STATUSES.find((s) => s.value === (value || "new"));
  return (
    <Select value={current.value} onValueChange={onChange}>
      <SelectTrigger data-testid={testId} className={`h-8 w-[130px] border-none text-[12px] font-semibold ${current.cls}`}>
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        {STATUSES.map((s) => (
          <SelectItem key={s.value} value={s.value} data-testid={`${testId}-${s.value}`}>{s.label}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
